import React from "react";
import { useGetShortcutData } from "./hooks";
import { type ShortcutTypes, type ShortcutDataWithRef } from "./models";

interface Props {
  shortcutOrder: ShortcutTypes[]
}

const ShortcutsApp = (props: Props) => {
  const shortcutData = useGetShortcutData(props.shortcutOrder);

  const scrollToPanel = async (shortcut: ShortcutDataWithRef) => {
    if (shortcut.refToScrollTo.current) {
      await scrollIntoViewAsync(shortcut.refToScrollTo.current);
    } else {
      console.warn("Could not scroll to panel, ref was null");
    }
  };

  const onAddClicked = async (shortcut: ShortcutDataWithRef) => {
    await scrollToPanel(shortcut);
    shortcut.onAddClicked();
  };

  return <div className="flex-column gap-mini">
    {shortcutData.map((s) => {
      return <div key={s.label} className="flex gap-mini s1-shortcut-row">
        <div className="hoverable card-floating-bg radius flex grow1" onClick={async () => scrollToPanel(s)}>
          <div className="grow1">
            {s.label}
          </div>
          {(s.totalItems > 0) && <div>{s.totalItems}</div>}
        </div>
        {(s.onAddClicked) && <div className="s1-shortcut-plus hoverable " onClick={async () => onAddClicked(s)}>
          <i className="icon-plus mini" />
        </div>}

        {(!s.onAddClicked) && <div className="s1-shortcut-plus">                </div>}
      </div>;
    })}
  </div >;
};

async function scrollIntoViewAsync(element) {
  return new Promise<void>(resolve => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.disconnect();

          setTimeout(resolve, 200);
        }
      });
    });

    observer.observe(element);
    element.scrollIntoView({ behavior: "smooth" });
  });
}

export default ShortcutsApp;